<template>
  <v-dialog
    :value="value"
    width="400"
    v-on="$listeners"
  >
    <v-card>
      <v-card-title>
        {{ cardTitle }}
      </v-card-title>
      <v-card-text>
        <p v-html="descriptionText"></p>
        <v-list v-if="childProfile" outlined>
          <v-list-item>
            <v-list-item-avatar tile>
              <v-img :src="childProfileAvatar" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>{{ childProfile.id }}</v-list-item-subtitle>
              <v-list-item-title>{{ childProfile.nickname }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          @click="close"
        >
          Close
        </v-btn>
        <v-spacer />
        <v-btn
          text
          color="red"
          @click="logoutProfile"
        >
          {{ actionName }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isExpiredJWT } from '@/helpers/auth';
import { AVATARS_FOLDER_URL } from '@/configs/urls';

export default {
  name: 'LogOutProfileDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    profileId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      parentAccount: 'parent/parentAccount',
      childProfiles: 'children/getChildren',
    }),
    cardTitle() {
      if (this.hasValidChildToken) {
        return 'Log out child profile';
      }
      if (this.hasValidParentToken) {
        return 'Log out parent account';
      }
      return 'Remove profile card';
    },
    descriptionText() {
      if (this.hasValidChildToken) {
        return 'Are you sure you want to log out of your child profile? Your profile can still be logged in using parent account, so you need to log out parent account to log out child profile completely.<br> You will not be able to use your profile again if you don\'t have any credentials and your profile is not connected to the parent account';
      }
      if (this.hasValidParentToken) {
        return 'It seems that your profile is logged in using parent account. Are you sure you want to log out of your parent account and remove all connected profiles from the list?';
      }
      return 'Are you sure you want to remove profile card from the list? It seems that your profile doesn\'t have token or the token has been expired';
    },
    actionName() {
      if (this.hasValidChildToken || this.hasValidParentToken) {
        return 'Logout';
      }
      return 'Remove';
    },
    childProfile() {
      return this.childProfiles.find(c => c.id === this.profileId);
    },
    hasValidChildToken() {
      return this.childProfile?.jwt && !isExpiredJWT(this.childProfile.jwt);
    },
    hasValidParentToken() {
      return this.childProfile
        && this.parentAccount?.jwt
        && !isExpiredJWT(this.parentAccount.jwt)
        && this.childProfile.parent_id === this.parentAccount._id;
    },
    childProfileAvatar() {
      if (!this.childProfile.avatar) return null;
      return `${AVATARS_FOLDER_URL}${this.childProfile.avatar}`;
    },
  },
  methods: {
    ...mapActions({
      logoutParent: 'parent/logoutParent',
      logoutChild: 'children/logoutChild',
    }),
    close() {
      this.$emit('input', false);
    },
    logoutProfile() {
      if (!this.hasValidChildToken && this.hasValidParentToken) {
        this.logoutParent();
      } else {
        this.logoutChild(this.profileId);
      }

      this.close();
    },
  },
};
</script>
